import './SearchHeaderStyle.scss';

import {
  OutlineButton,
  PrimaryButton,
  TextInputV2,
} from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React from 'react';
import Select, { components } from 'react-select';
import { Icon } from 'src/core/components';

const SearchHeaderComponent = ({
  searchFormData,
  menuGroups,
  selectedMenuItem,
  handleOnChange,
  handleSearchButtonClick,
  handleAdvancedSearch,
  handleKeyPress,
}) => {
  console.log('selectedMenuItem=> ', selectedMenuItem);
  console.log('searchFormData=> ', searchFormData);
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <Icon size="8" name="caret-down" />
      </components.DropdownIndicator>
    );
  };

  const selectDropdownOptions = menuGroups?.map((group) => {
    return {
      label: group.category.name,
      options: group.items.map((item) => ({
        value: `${group.category.name}-${item.name}`,
        label: item.name,
        category: group.category.name,
        categoryNr: group.category.categoryNr,
        subcategoryNr: item.subcategoryNr,
      })),
    };
  });

  const viewAllOption = [
    {
      label: 'View All',
      options: [
        {
          value: 'View All',
          label: 'View All',
          category: 'viewAll',
          subcategoryNr: '',
        },
      ],
    },
  ];

  const groupedOptions = [...viewAllOption, ...selectDropdownOptions];

  return (
    <div className="search-header-container">
      <div className="row gx-0">
        <div className="col">
          <div className="position-relative">
            <p className="labelText">
              {searchFormData?.category === 'viewAll'
                ? 'Category Name'
                : searchFormData?.category || 'Select'}
            </p>
            <Select
              // menuIsOpen={true}
              isSearchable={false}
              defaultValue={viewAllOption[0]}
              value={{
                label:
                  searchFormData?.label || viewAllOption[0].options[0].label,
                value:
                  searchFormData?.value || viewAllOption[0].options[0].value,
              }}
              components={{ DropdownIndicator }}
              options={groupedOptions}
              classNamePrefix="react-select"
              onChange={handleOnChange}
              classNames={{
                control: (state) => {
                  return state.isFocused ? 'grey' : 'red';
                },
              }}
            />
          </div>
        </div>
        <div className="col col-md-5">
          <div className="position-relative">
            <TextInputV2
              id="search-field"
              value={searchFormData?.searchText}
              onChange={handleOnChange}
              placeholder={'Search by name...'}
              onKeyPress={handleKeyPress}
            />
            <button
              type="button"
              className="closeIcon btn btn-link"
              onClick={() => handleSearchButtonClick('clearAll')}
            >
              Clear all
            </button>
          </div>
        </div>

        <div className="col-auto">
          <PrimaryButton
            onClick={handleSearchButtonClick}
            className="position-relative"
          >
            Search{' '}
            {false && <div className="search-btn-loader">...Loading</div>}
          </PrimaryButton>
        </div>
        <div className="col-auto ps-3">
          <OutlineButton
            onClick={handleAdvancedSearch}
            className="position-relative"
          >
            Advanced Search
          </OutlineButton>
        </div>
      </div>
    </div>
  );
};

SearchHeaderComponent.propTypes = {
  searchFormData: PropTypes.object.isRequired,
  selectedMenuItem: PropTypes.object,
  menuGroups: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleSearchButtonClick: PropTypes.func.isRequired,
  handleAdvancedSearch: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
};

export default SearchHeaderComponent;
